module.exports = __webpack_public_path__ + "static/media/Finnovex-Qatar-Infographics.5e4b4734.png";